module.exports = __webpack_public_path__ + "img/kv01_sp.c1ed90fd.jpg";